import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AccountService } from 'app/core/services/account.service';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { User } from 'app/shared/models/User';
import { UserService } from 'app/core/services/user.service';
import { Result } from 'app/core/models/result';
import { Location } from '@angular/common';
import { AlertMessageComponent } from 'app/shared/components/alert-message/alert-message.component';
import { CompanyListModel } from 'app/company/models/company-list.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    templateUrl: './user-edit.component.html',
    styleUrls: ['./user-edit.component.css']
})
export class UserEditComponent implements OnInit {
    user: User;
    userId: string;
    currentUser: User;
    errors: string[];
    submitAttempt: boolean = false;
    @ViewChild('registerForm', { static: false }) registerForm: NgForm;
    @ViewChild(AlertMessageComponent, { static: false }) alertMessage: AlertMessageComponent;
    headerTitle: IHeaderTitle;
    isEditMode: boolean = false;
    companies: CompanyListModel[];
    selectedUserId: string;

    constructor(
        private userService: UserService,
        private router: Router,
        private _activatedRoute: ActivatedRoute,
        private accountService: AccountService,
        private location: Location,
        private modalService: NgbModal
    ) { }

    public register(): void {
        this.submitAttempt = true;
        if (this.registerForm.valid) {
            this.userService.editUser(this.user).subscribe(
                user => {
                    this.alertMessage.showMessage();
                },
                error => {
                    this.handleRegisterError(error);
                }
            );
        }
    }

    ngOnInit(): void {
        this.userId = this._activatedRoute.snapshot.params['id'];
        this.load();
    }

    load() {
        this.userService.getUser(this._activatedRoute.snapshot.params['id']).subscribe(
            user => {
                this.user = user;
                this.headerTitle = {
                    title: this.user.email,
                    breadcrumbs: [
                        { title: 'Users', url: ['/account/users'] }
                    ]
                }
            }, error => {
                console.log(error);
            }
        );
        let currentUserSubscription = this.accountService.getUser().subscribe(
            user => {
                this.currentUser = user;
                currentUserSubscription.unsubscribe();
            }
        );
        this.userService.getCompanyUsers(this.userId).subscribe(
            companies => {
                this.companies = companies;
            },
            error => this.errors = error.errorList
        );
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }

    handleRegisterError(error: Result) {
        this.errors = error.errorList;
    }

    successClicked($event: any): void {
        this.router.navigate(['./account/users']);
    }

    onHide($event: any): void { }

    onBack($event: any): void {
        this.location.back();
    }


    deleteUser() {
        this.userService.deleteUser(this.selectedUserId).subscribe(
            result => this.router.navigate(['./account/users']),
            error => console.log(error)
        );
    }

    openCannotDeleteUser(content) {
        this.modalService.open(content);
    }

    userCompaniesUpdated(event) {
        this.load();
    }
}
